import { render, staticRenderFns } from "./ResearchRoot.vue?vue&type=template&id=1cc751ba&scoped=true&"
import script from "./ResearchRoot.vue?vue&type=script&lang=js&"
export * from "./ResearchRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc751ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cc751ba')) {
      api.createRecord('1cc751ba', component.options)
    } else {
      api.reload('1cc751ba', component.options)
    }
    module.hot.accept("./ResearchRoot.vue?vue&type=template&id=1cc751ba&scoped=true&", function () {
      api.rerender('1cc751ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/landing-page/components/research/ResearchRoot.vue"
export default component.exports